<template>
  <q-inner-loading :showing="visible">
    <q-spinner color="primary-darkened" size="80px" :class="{ 'fixed-center': fixedCenter }" />
    <div class="text-h5 text-primary">{{ message }}</div>
  </q-inner-loading>
</template>
<script>
export default {
  name: 'Loader',
  props: {
    fixedCenter: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
